import { Avatar, Button, DialogActions, DialogContent, DialogContentText, Stack, Typography } from "@mui/material";
import apiManagerUser from "api/manager-users";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfo } from "store/user/userInfoSlice";
import { TOAST_DEFAULT } from "constants/toast";
import { stringAvatar } from "utils/functions/common";
import { setCloseDialogCC, toastError, toastSuccess } from "utils/helpers";
import { DIALOG_ID } from "./constant";
import DialogBaseCC from "./DialogBaseCC";

const DialogDeleteAvatar = () => {
    const userInfo = useSelector((state) => state.userInfo.userInfo, _.isEqual);
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const handleDeleteAvatar = async () => {
        try {
            const res = await apiManagerUser.removeAvatar()

            if(res.status === 200) {
                dispatch(setUserInfo({ ...userInfo, images: null }))
                toastSuccess(t('toast.updateProfileSuccess'))
                setCloseDialogCC()
            } else toastError(t(TOAST_DEFAULT.ERROR))
        } catch (err) {
            console.log('[Error] handleDeleteAvatar', err)
            toastError(t(TOAST_DEFAULT.ERROR))
        }
    }

    return (
        <DialogBaseCC id={DIALOG_ID.DELETE_AVATAR} title={t('title.removeAvatar')}>
            <DialogContent>
                <DialogContentText sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '1rem' }}>
                    <Stack className='circle-avatar' direction="row" spacing={2}>
                        <Avatar style={{ margin: 0 }} {...stringAvatar(userInfo?.name, userInfo)} />
                    </Stack>
                    <Stack mt={2}>
                        <Typography>{t('modal.confirmDelAvatar')}</Typography>
                        <Typography>{t('modal.descDelAvatar')}</Typography>
                    </Stack>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button id="btn-cancel-delete-avatar" variant="outlined" onClick={setCloseDialogCC}>{t('modal.cancel')}</Button>
                <Button id="btn-confirm-delete-avatar" onClick={handleDeleteAvatar}>{t('modal.confirm')}</Button>
            </DialogActions>
        </DialogBaseCC>
    );
};

export default DialogDeleteAvatar;
